/**
 * API Key 设置。
 * 独立成弹窗而非做一个设置页：它是「让请求跑通」的前置条件，
 * 401 时需要能从任何页面立刻打开。
 */

import { useEffect, useState } from 'react';
import { Alert, Input, Modal, Space, Typography } from 'antd';
import { useSettingsStore } from '@/store/settings';

interface Props {
  open: boolean;
  onClose: () => void;
  /** 因 401 弹出时给一句上下文说明 */
  reason?: string;
}

export function ApiKeyModal({ open, onClose, reason }: Props) {
  const apiKey = useSettingsStore((s) => s.apiKey);
  const setApiKey = useSettingsStore((s) => s.setApiKey);
  const [value, setValue] = useState(apiKey);

  useEffect(() => {
    if (open) setValue(apiKey);
  }, [open, apiKey]);

  return (
    <Modal
      open={open}
      title="API Key"
      okText="保存"
      cancelText="取消"
      onCancel={onClose}
      onOk={() => {
        setApiKey(value.trim());
        onClose();
      }}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        {reason ? <Alert type="warning" showIcon message={reason} /> : null}
        <Typography.Text type="secondary">
          以 <Typography.Text code>Authorization: Bearer</Typography.Text> 发送，仅存在本机浏览器。
        </Typography.Text>
        <Input.Password
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="sk-..."
          autoFocus
        />
      </Space>
    </Modal>
  );
}
